import React, { useState } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import AboutBreadcrumb from "../../components/AboutPage/AboutBreadcrumb/AboutBreadcrumb";
import "./Careers.css";

const Careers = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted successfully (backend can be connected)");
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      subject: "",
      message: "",
    });
  };

  return (
    <>
      <Header />
      <AboutBreadcrumb label="Careers" />

      <section className="careers-section">
        <div className="careers-container">

          {/* LEFT FORM */}
          <div className="careers-form">
            <h2>Careers With INTELBUILD</h2>
            <p>
              We are constantly looking out for talented and professional
              detailers, checkers, and engineers. If you are a professional who
              can make a difference by constantly contributing to the
              organization and an evolving personality who aims at higher
              growth aspiration with a zeal to prove yourself, please feel free
              to reach out to us.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>First Name</label>
                  <input
                    type="text"
                    name="firstName"
                    placeholder="Enter First name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Enter Last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email Address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Subject</label>
                  <input
                    type="text"
                    name="subject"
                    placeholder="Enter Subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-group full-width">
                <label>Message</label>
                <textarea
                  name="message"
                  placeholder="Enter Message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="send-btn">
                SEND
              </button>
            </form>
          </div>

          {/* RIGHT IMAGE */}
          <div className="careers-image">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/career.webp`}
              alt="Careers"
            />
          </div>

        </div>
      </section>

      <Footer />
    </>
  );
};

export default Careers;
